module.exports = __webpack_public_path__ + "img/list-view-inactive.1e7d0dab.svg";